// extracted by css-extract-rspack-plugin
export default {"positionText":"PositionCorrection_positionText__+YMAa"};